import { useEffect } from "react";
import { Card } from "@powerdiary/components-library/lib";
import {
    useClientPortalSelector,
    selectBooking,
    useClientPortalDispatch,
    clearBookingState,
    goToStep,
} from "../../../../redux";
import { BookingStatus, STEP_CONFIRMATION, STEP_LOCATION } from "../../bookingSlice.types";
import { useStepComponentResolver } from "../../hooks/useStepComponentResolver";
import { useBookingNavigation } from "../../hooks/useBookingNavigation";
import AppointmentBookingHeader from "../AppointmentBookingHeader";
import styles from "./BookingFlow.module.css";

export default function BookingFlow() {
    const { session } = useClientPortalSelector(selectBooking);
    const { getStepComponent } = useStepComponentResolver();
    const { effectiveCurrentStep } = useBookingNavigation();
    const dispatch = useClientPortalDispatch();

    const hasAnyCompletedSteps = useClientPortalSelector((state) => {
        const booking = selectBooking(state);
        return (
            booking.location.isCompleted ||
            booking.service.isCompleted ||
            booking.provider.isCompleted ||
            booking.availability.isCompleted ||
            booking.registration.isCompleted
        );
    });

    useEffect(() => {
        if (
            effectiveCurrentStep === STEP_CONFIRMATION &&
            !session.completedBookingData &&
            session.bookingStatus === BookingStatus.IN_PROGRESS &&
            !hasAnyCompletedSteps
        ) {
            dispatch(clearBookingState());
            dispatch(goToStep(STEP_LOCATION));
        }
    }, [dispatch, session.completedBookingData, effectiveCurrentStep, session.bookingStatus, hasAnyCompletedSteps]);

    const StepComponent = getStepComponent(effectiveCurrentStep);

    return (
        <Card className={styles.wrapper} data-test-id="section_booking_flow">
            {session.bookingStatus === BookingStatus.IN_PROGRESS && <AppointmentBookingHeader />}
            <StepComponent />
        </Card>
    );
}
